export default "__VITE_ASSET__BDboSFlb__"